import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ICoach } from '../models/coach.model';

/**
 * Holds the authenticated coach for the app. The panel has a single actor and a small
 * state surface, so a subject is enough — no store setup like the student app needs.
 */
@Injectable({providedIn: 'root'})
export class CoachStateService {
  private readonly currentCoachSubject = new BehaviorSubject<ICoach | null>(null);

  readonly currentCoach$: Observable<ICoach | null> = this.currentCoachSubject.asObservable();

  get currentCoach(): ICoach | null {
    return this.currentCoachSubject.value;
  }

  setCurrentCoach(coach: ICoach | null) {
    this.currentCoachSubject.next(coach);
  }

  clear() {
    this.currentCoachSubject.next(null);
  }
}
